/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Watertreatmentdefect2Inputs */



/**
* | output |
* | --- |
* | "Water treatment system defect" |
*
* @param {Br_History_Key_Watertreatmentdefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_watertreatmentdefect2 = /** @type {((inputs?: Br_History_Key_Watertreatmentdefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Watertreatmentdefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Water treatment system defect")
	return /** @type {LocalizedString} */ ("Défaut du système de traitement d'eau")
});
export { br_history_key_watertreatmentdefect2 as "br_history_key_waterTreatmentDefect" }